import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {trainingScheduleActions} from "./trainingScheduleSlice";
import {trainingScheduleApi} from "~/api";

function* fetchTrainingScheduleList(action) {
	try {
		const response = yield call(trainingScheduleApi.gets, action.payload);
		yield put(trainingScheduleActions.fetchDataSuccess(response));
	}
	catch (error) {
		console.log('Failed to fetch training schedule list', error);
		let message = error.message;
		if(error?.response?.data?.message) message = error.response.data.message;
		yield put(trainingScheduleActions.fetchDataFailed(message));
	}
}

function* handleSearchDebounce(action) {
	yield put(trainingScheduleActions.setFilter(action.payload));
}

export default function* trainingScheduleSaga() {
	yield takeLatest(trainingScheduleActions.fetchData.type, fetchTrainingScheduleList);
	yield debounce(500, trainingScheduleActions.setFilterWithDebounce.type, handleSearchDebounce);
}
